import { createRouter, createWebHistory } from 'vue-router';

import Login from '/src/components/pages/Login.vue';
import UserSetup from '/src/components/pages/UserSetup.vue';
import ForgotPassword from '/src/components/pages/ForgotPassword.vue';
import ChangePassword from '/src/components/pages/ChangePassword.vue';
import PassThrough from '/src/components/PassThrough.vue';
import AdminPassThrough from '/src/components/pages/beta/layouts/admin/AdminPassThrough.vue';


// Dashboard Layout
import DashboardLayout from '/src/components/pages/beta/layouts/Root.vue';

// Retainer Pages
import RetainerLayout from '/src/components/pages/beta/layouts/retainer/Root.vue';
import RetainerReportsLayout from '/src/components/pages/beta/layouts/retainer/Reports.vue';

import Dashboard from '/src/components/pages/beta/retainer/Dashboard.vue';
import RetainerSettings from '/src/components/pages/beta/retainer/Edit.vue';
import Services from '/src/components/pages/beta/retainer/Services.vue';
import SendMail from '/src/components/pages/SendMail.vue';
import Account from '/src/components/pages/beta/retainer/Account.vue';
import Contacts from '/src/components/pages/beta/retainer/Contacts.vue';

// Reports Pages
import ReportsOverview from '/src/components/pages/beta/retainer/reports/Overview.vue';
import ReportsGraph from '/src/components/pages/beta/retainer/reports/Graph.vue';
import ReportsListing from '/src/components/pages/beta/retainer/reports/Listing.vue';
import EditListing from '/src/components/pages/beta/retainer/reports/EditListing.vue';
import SendReport from '/src/components/pages/beta/retainer/reports/SendReport.vue';

// Admin Pages
import TeamDashboard from '/src/components/pages/beta/admin/TeamDashboard.vue';
import AdminDashboard from '/src/components/pages/beta/admin/dashboard/Dashboard.vue';
import ClientsNeedingAttention from '/src/components/pages/beta/admin/dashboard/ClientsNeedingAttention.vue';
import RetainersToWatch from '/src/components/pages/beta/admin/dashboard/RetainersToWatch.vue';

import ClientRetainers from '/src/components/pages/beta/admin/clients/ClientRetainers.vue';
import RetainerNewClient from '/src/components/pages/beta/admin/clients/AddClient.vue';

import RetainersOverview from '/src/components/pages/RetainersOverview.vue';

import Users from '/src/components/pages/Users.vue';
import UserProfile from '/src/components/pages/UserProfile.vue';
import AddNewUser from '/src/components/objects/AddUserForm.vue';

import Settings from '/src/components/pages/beta/admin/Settings.vue';

const routes = [
    {
        path: '/',
        redirect: { name: 'Login' }
    },
    {
        path: '/login',
        name: 'Login',
        component: Login,
        props: true
    },
    {
        path: '/user-setup',
        name: 'UserSetup',
        component: UserSetup
    },
    {
        path: '/forgot-password',
        name: 'ForgotPassword',
        component: ForgotPassword
    },
    {
        path: '/change-password/:userid',
        name: 'ChangePassword',
        component: ChangePassword
    },
    {
        path: '/beta-dashboard/:pathMatch(.*)*',
        component: PassThrough,
        name: 'Dashboard Backup Redirect',
        redirect: { name: 'Beta Dashboard' },
    },
    {
        path: '/dashboard',
        component: DashboardLayout,
        name: 'Beta Dashboard',
        redirect: { name: 'Retainer Dashboard', params: {retainerId: 0} },
        props: true,
        children: [
            {
                path: 'retainer/:retainerId',
                name: 'Retainer Dashboard',
                component: RetainerLayout,
                redirect: { name: 'Beta Dashboard Home' },
                props: true,
                children: [
                    {
                        path: '',
                        name: 'Beta Dashboard Home',
                        props: true,
                        component: Dashboard
                    },
                    {
                        path: 'reports',
                        name: 'Beta Dashboard Reports',
                        component: PassThrough,
                        redirect: { name: 'Beta Dashboard Reports Overview' },
                        props: true,
                        children: [
                            {
                                path: '',
                                name: 'beta-reports-layout',
                                component: RetainerReportsLayout,
                                props: true,
                                children: [
                                    {
                                        path: 'overview',
                                        name: 'Beta Dashboard Reports Overview',
                                        component: ReportsOverview,
                                        props: true,
                                    },
                                    {
                                        path: 'graph',
                                        name: 'Beta Dashboard Reports Graph',
                                        component: ReportsGraph,
                                        props: true,
                                    },
                                ]
                            },
                            {
                                path: 'listing',
                                component: PassThrough,
                                name: 'listing-parent',
                                props: true,
                                children: [
                                    {
                                        path: '',
                                        name: 'Beta Dashboard Reports Listing',
                                        component: ReportsListing,
                                        props: true,
                                        meta: { fullWidth: true },
                                    },
                                    {
                                        path: 'edit/:dataid',
                                        name: 'Edit',
                                        component: EditListing,
                                        props: true
                                    },
                                    {
                                        path: 'send-report',
                                        name: 'Send Report',
                                        component: SendReport,
                                        props: true
                                    },
                                ]
                            },
                        ]
                    },
                    {
                        path: 'account',
                        name: 'Beta Dashboard Details',
                        props: true,
                        component: Account
                    },
                    {
                        path: 'contacts',
                        name: 'Beta Dashboard Contacts',
                        props: true,
                        component: Contacts,
                        children: [
                            {
                                path: 'create',
                                name: 'Client - Add new contact',
                                component: AddNewUser,
                            },
                            {
                                path: 'profile/:userid',
                                name: 'Client - User profile',
                                component: UserProfile,
                                props: true
                            },
                        ]
                    },
                    {
                        path: 'services',
                        name: 'Beta Dashboard Services',
                        props: true,
                        component: Services
                    },
                    {
                        path: 'send-mail',
                        name: 'Send mail',
                        component: SendMail,
                        props: true
                    },
                    {
                        path: 'retainer-settings',
                        name: 'Retainer Settings',
                        component: RetainerSettings,
                        props: true
                    },
                    {
                        path: 'send-mail',
                        name: 'Send mail',
                        component: SendMail,
                        props: true
                    },
                ]
            },
            {
                path: 'admin',
                component: AdminPassThrough,
                name: 'Admin Dashboard',
                props: true,
                children: [
                    {
                        path: '',
                        name: 'Beta Admin Dashboard',
                        component: AdminDashboard,
                        children: [
                            {
                                path: 'clients-needing-attention',
                                name: 'Admin - Clients needing attention',
                                component: ClientsNeedingAttention,
                            },
                            {
                                path: 'retainers-to-watch',
                                name: 'Admin - Retainers to watch',
                                component: RetainersToWatch,
                            },
                        ]
                    },
                    {
                        path: 'team-overview',
                        name: 'Beta Team Overview',
                        component: TeamDashboard,
                    },
                    {
                        path: 'settings',
                        name: 'Beta App Settings',
                        component: Settings
                    },
                    {
                        path: 'clients',
                        name: 'Admin - Beta clients',
                        component: ClientRetainers,
                        children: [
                            {
                                path: 'create',
                                name: 'Admin - Add new client',
                                component: RetainerNewClient,
                            },
                            {
                                path: ':clientId',
                                name: 'Admin - Edit client',
                                component: RetainerNewClient,
                            },
                        ]
                    },
                    {
                        path: 'retainers',
                        name: 'Beta Retainers',
                        component: RetainersOverview,
                    },
                    {
                        path: 'contacts',
                        component: PassThrough,
                        name: 'Beta Admin Contacts',
                        redirect: { name: 'Users' },
                        props: true,
                        children: [
                            {
                                path: '',
                                name: 'Users',
                                component: Users,
                                props: true,
                                children: [
                                    {
                                        path: 'create',
                                        name: 'Admin - Add new contact',
                                        component: AddNewUser,
                                    },
                                    {
                                        path: 'profile/:userid',
                                        name: 'Admin - User profile',
                                        component: UserProfile,
                                        props: true
                                    },
                                ]
                            },
                        ]
                    },
                ]
            },
        ]
    },
];

let router = createRouter({
    history: createWebHistory(),
    routes,
});

export default router;